import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { WhoIHelp } from './components/WhoIHelp';
import { ProblemSolution } from './components/ProblemSolution';
import { MyStory } from './components/MyStory';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { PodcastCTA } from './components/PodcastCTA';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-dark-darker min-h-screen text-white overflow-x-hidden" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <WhoIHelp data-id="element-4" />
        <ProblemSolution data-id="element-5" />
        <MyStory data-id="element-6" />
        <Services data-id="element-7" />
        <Testimonials data-id="element-8" />
        <PodcastCTA data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}